import { useState, useEffect, useRef } from "react";
import "../styles/Pms.css";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { fetchForms } from "../services/pms";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import LoadingScreen from "../components/LoadingScreen";
import { WATOMS_PMS_ROLE_PERMISSION, WATOMS_PMS_FORMS_ORDER, WATOMS_PMS_LIST } from "../constants/constants";
import DenyAccessPage from "../components/DenyAccessPage";
import PmsCategoryCard from "components/pms/PmsCategoryCard";
import PmsCategoryCardDetail from "components/pms/PmsCategoryCardDetail";
import { useTheme } from "context/ThemeContext";
import WatomsNavbar from "components/navbars/WatomsNavbar";
import ModernBackground from "components/ui/ModernBackground";
import ModelNaviagtionSideBar from "components/ui/ModelNavigationSideBar";

const TomsPms = () => {
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();
  const focusedCardRef = useRef(null);
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [focusedCardId, setFocusedCardId] = useState(null);
  const [focusExit, setFocusExit] = useState(false);
  const { darkMode } = useTheme();
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    const loadForms = async () => {
      try {
        const rawData = await fetchForms(userInfo);
        const filtertomsForms = rawData?.filter(
          (filter) =>
            filter.type !== "360 Individual Assessment" &&
            filter.type !== "360 Curriculum Assessment" &&
            filter.type !== "normal" &&
            filter.type !== "Wisdom ClassRoom Observation" &&
            filter.code !== "TS | TG" &&
            filter.code !== "TS | TE" &&
            filter.code !== "TS | TR" &&
            filter.code !== "TS | W"
        );

        const groupedData = [];
        const filteredGroupedData = [];

        filtertomsForms.forEach((item) => {
          const codeKey2 = item.code.split(" | ")[1];
          const codePermission = item.code.split(" | ")[0];
          const codePermission2 = WATOMS_PMS_ROLE_PERMISSION[codePermission] || null;
          const codeKey = WATOMS_PMS_LIST[codeKey2] || null;
          const codeKey3 = WATOMS_PMS_ROLE_PERMISSION[codeKey2] || null;

          
          if (codePermission2 === userInfo?.user_role || (codePermission2 === "Self" && codeKey3 === userInfo?.user_role) || userInfo?.user_role === "Operations Excellence Lead" || userInfo?.user_role === "Super Admin" || (codePermission === "MGR" && userInfo?.user_role === "Manager") || (codePermission === "AD" && userInfo?.user_role === "ADMIN") || (codePermission === "T" && userInfo?.user_role === "Teacher") || (codePermission === "OEL" && userInfo?.user_role === "Operations Excellence Lead") || (codePermission === "OEL" && userInfo?.user_role === "Super Admin") || (codePermission === "TR" && userInfo?.user_role === "Student")) {
            let existingGroup = groupedData.find(
              (group) => group.code === codeKey
            );

            if (!existingGroup) {
              existingGroup = {
                id: item.id,
                code: codeKey,
                reviewee: codeKey3,
                codeAr: codeKey,
                forms: [],
              };
              groupedData.push(existingGroup);
            }

            existingGroup.forms.push({
              id: item.id,
              en_name: item.ar_name,
              ar_name: item.ar_name,
              program: item.programs,
              category: item.category,
              permission: codePermission2,
            });
          }
        });

        if (userInfo?.user_role === "Student") {
          const filtered = groupedData.map(type => ({ ...type, forms: type.forms.filter(form => form.category.id === userInfo?.student_specialization?.subject[0]?.subject?.category?.id) }))
          filteredGroupedData.push(...filtered);
        } else if (userInfo?.user_role === "Teacher") {
          const filtered = groupedData.map(type => ({ ...type, forms: type.forms.filter(form => form.category.id === userInfo?.teacher_subject?.category?.id || form.category.id === 1) }))
          filteredGroupedData.push(...filtered)
        } else {
          filteredGroupedData.push(...groupedData);
        }

        const generalForms = filteredGroupedData.filter(
          (filteredData) => filteredData.code !== "التنمية المهنية"
        );
        const filteredGeneralForms = generalForms.filter(
          (filteredData) => filteredData.code !== "Daily Operations"
        );
        const newForms = WATOMS_PMS_FORMS_ORDER.map((id) => filteredGeneralForms[id]).filter((f) => f !== undefined);
        setForms(newForms);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadForms();
  }, [userInfo]);

  // Escape key support to exit focus mode
  useEffect(() => {
    if (!focusedCardId) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleFocusExit();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [focusedCardId]);

  // Escape key support for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && activeModal) {
        setActiveModal(null);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeModal]);

  const handleClick = (id, en_name, ar_name, code, reviewee) => {
    navigate(`/watoms/pms/form/${id}`, {
      state: { formEnName: en_name, formArName: ar_name, lang: language, code: code, reviewee },
    });
  };

  // Handle focus exit with animation
  const handleFocusExit = () => {
    setFocusExit(true);
    setTimeout(() => {
      setFocusedCardId(null);
      setFocusExit(false);
    }, 400); // match exit animation duration
  };

  if (loading) return <LoadingScreen />;
  if (error?.status === 403) return <Navigate to="/login" state={{ from: location }} replace />;
  if (error) return <p>Error: {error.message}</p>;
  if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
  if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
  if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;

  return (
    <div className={`min-h-screen w-full font-[Cairo,sans-serif] transition-colors duration-500 ${darkMode ? 'bg-watomsBlue text-white' : 'bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-900'} relative overflow-hidden`}>
      <ModernBackground />
      <ModelNaviagtionSideBar system="watoms" />
      <WatomsNavbar
        backButton="/watoms"
      />
      {/* Modern App Menu */}
      <div className="flex flex-col items-center justify-center min-h-[80vh] w-full relative">
        {/* Categories Section - centered and constrained */}
        <div className="w-full max-w-6xl mx-auto">
          <h2 className="text-3xl font-extrabold mb-2 text-center bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
            {language ? 'Performance Categories' : 'فئات الأداء'}
          </h2>
          {/* Centered, subtle line under heading */}
          <div className="mx-auto mb-10" style={{ height: '3px', width: '180px', background: 'linear-gradient(90deg,#a259f7 0%,#667eea 100%)', borderRadius: '2px', opacity: 0.18 }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mb-4">
            {forms.map((category, idx) => (<PmsCategoryCard key={category.id} id={category.id} title={category.code} totalForms={category.forms.length} setFocusedCardId={setFocusedCardId} />))}
            {userInfo?.user_role !== "Student" && <PmsCategoryCard id="الاشراف اليومي" title="الاشراف اليومي" totalForms={2} setFocusedCardId={setFocusedCardId} />}
            {(userInfo?.organization_id === 13 || userInfo?.user_role === "Manager") && <PmsCategoryCard id="تقرير الاداء" title="تقرير الاداء" totalForms={1} setFocusedCardId={setFocusedCardId} />}
          </div>
        </div>
      </div>
      {/* Focus Mode Rendering */}
      {focusedCardId && focusedCardId !== "التنمية المهنية" && focusedCardId !== "الاشراف اليومي" && focusedCardId !== "تقرير الاداء" &&
        <PmsCategoryCardDetail focusExit={focusExit} handleFocusExit={handleFocusExit} setFocusedCardId={setFocusedCardId} title={forms.filter(type => type.id === focusedCardId)[0].code} totalForms={forms.filter(type => type.id === focusedCardId)[0].forms.length} focusedCardRef={focusedCardRef} forms={[
          ...forms.filter(type => type.id === focusedCardId).flatMap(type =>
            type.forms.map(form => ({
              ...form,
              handleFormClick: () => handleClick(form.id, form.ar_name, form.ar_name, form.permission, type.reviewee)
            }))
          )
        ]} />}
      {focusedCardId && focusedCardId === "الاشراف اليومي" && <PmsCategoryCardDetail focusExit={focusExit} handleFocusExit={handleFocusExit} setFocusedCardId={setFocusedCardId} title={"الاشراف اليومي"} totalForms={2} focusedCardRef={focusedCardRef} forms={[
        {
          id: "غياب المتدرب",
          handleFormClick: () => navigate(`/watoms/pms/trainee-absence`),
          ar_name: "غياب المتدرب",
        },
        {
          id: "وقائع المركز",
          handleFormClick: () => navigate(`/watoms/pms/inistitute-incident`),
          ar_name: "وقائع المركز",
        }
      ]} />}
      {focusedCardId && focusedCardId === "تقرير الاداء" && <PmsCategoryCardDetail focusExit={focusExit} handleFocusExit={handleFocusExit} setFocusedCardId={setFocusedCardId} title={"تقرير الاداء"} totalForms={1} focusedCardRef={focusedCardRef} forms={[
        {
          id: "تقرير الاداء",
          handleFormClick: () => navigate(`/watoms/pms/performance-report`),
          ar_name: "تقرير الاداء",
        }
      ]} />}
    </div>
  );
};

export default TomsPms;